class ThornHeaderDrawer {
  constructor(header) {
    this.header = header;
    const updateHeaderHeight = () => {
      document.documentElement.style.setProperty('--th-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
    };
    updateHeaderHeight();
    this.headerResizeObserver = new ResizeObserver(updateHeaderHeight);
    this.headerResizeObserver.observe(header);
    this.trigger = header.querySelector('.th-header__menu-trigger');
    const drawerId = this.trigger?.getAttribute('aria-controls');
    this.drawer = drawerId ? document.getElementById(drawerId) : null;
    this.panel = this.drawer?.querySelector('.th-header__drawer-panel');
    this.closeButtons = this.drawer?.querySelectorAll('[data-th-header-close]') || [];
    this.navigationLinks = this.drawer?.querySelectorAll('a[href]') || [];
    if (!this.trigger || !this.drawer || !this.panel) return;

    this.trigger.addEventListener('click', () => this.open());
    this.closeButtons.forEach((button) => button.addEventListener('click', () => this.close()));
    this.navigationLinks.forEach((link) => {
      link.addEventListener('click', () => this.close({ restoreFocus: false }));
    });
    this.drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
      if (event.key === 'Tab') this.trapFocus(event);
    });
  }

  open() {
    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('th-header-drawer-open');
    this.panel.focus();
  }

  close({ restoreFocus = true } = {}) {
    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    this.trigger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('th-header-drawer-open');
    if (restoreFocus) this.trigger.focus();
  }

  trapFocus(event) {
    const focusable = [...this.panel.querySelectorAll('a[href], button:not([disabled]), summary, input:not([disabled]), [tabindex]:not([tabindex="-1"])')];
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}

document.querySelectorAll('.th-header').forEach((header) => new ThornHeaderDrawer(header));

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('.th-header').forEach((header) => new ThornHeaderDrawer(header));
});
